var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-app",
    [
      !_vm.isRecordingRole()
        ? _c(
            "v-overlay",
            { attrs: { value: !_vm.app.theme_loaded } },
            [
              _vm.app.room.settings != null && !_vm.youtbe_auth_complete
                ? _c("v-progress-circular", {
                    attrs: { indeterminate: "", size: "64" },
                  })
                : _vm.youtube_auth_window && _vm.youtbe_auth_complete
                ? _c(
                    "v-btn",
                    {
                      on: {
                        click: function ($event) {
                          return _vm.closeWindow()
                        },
                      },
                    },
                    [_vm._v("Close")]
                  )
                : _c(
                    "div",
                    { staticClass: "text-h5 text--disabled font-weight-bold" },
                    [_vm._v("No Room Found")]
                  ),
            ],
            1
          )
        : _vm._e(),
      _vm.app.theme_loaded ? _c("meeting-system-bar") : _vm._e(),
      _vm.app.theme_loaded && _vm.meeting.is_connected && !_vm.isRecordingRole()
        ? _c("meeting-navigation-drawer")
        : _vm._e(),
      _vm.app.theme_loaded
        ? _c(
            "v-main",
            { class: _vm.getBackgroundClass },
            [_c("router-view")],
            1
          )
        : _vm._e(),
      !_vm.meeting.leaving &&
      _vm.app.theme_loaded &&
      _vm.$route.name == "Meeting" &&
      !_vm.isRecordingRole()
        ? _c(
            "v-bottom-navigation",
            {
              style: `padding-right:${
                _vm.meeting.show_nav_drawer ? _vm.meeting.sidebar_width : "0"
              }px`,
              attrs: { grow: "" },
              model: {
                value: _vm.menu,
                callback: function ($$v) {
                  _vm.menu = $$v
                },
                expression: "menu",
              },
            },
            [
              _c(
                "v-btn",
                {
                  on: {
                    click: function ($event) {
                      return _vm.meeting.hmsActions.setLocalAudioEnabled(
                        !_vm.meeting.local_audio_enabled
                      )
                    },
                  },
                },
                [
                  _c("span", [
                    _vm._v(
                      _vm._s(
                        _vm.meeting.local_audio_enabled ? "Mute" : "Unmute"
                      )
                    ),
                  ]),
                  _c("v-icon", [
                    _vm._v(
                      _vm._s(
                        _vm.meeting.local_audio_enabled
                          ? "mdi-microphone"
                          : "mdi-microphone-off"
                      )
                    ),
                  ]),
                ],
                1
              ),
              _c("v-divider", { attrs: { vertical: "" } }),
              _c(
                "v-btn",
                {
                  on: {
                    click: function ($event) {
                      return _vm.meeting.hmsActions.setLocalVideoEnabled(
                        !_vm.meeting.local_video_enabled
                      )
                    },
                  },
                },
                [
                  _c("span", [
                    _vm._v(
                      _vm._s(
                        _vm.meeting.local_video_enabled ? "Hide" : "Unhide"
                      )
                    ),
                  ]),
                  _c("v-icon", [
                    _vm._v(
                      _vm._s(
                        _vm.meeting.local_video_enabled
                          ? "mdi-video"
                          : "mdi-video-off"
                      )
                    ),
                  ]),
                ],
                1
              ),
              _vm.meeting.is_connected &&
              (_vm.meeting.local_peer.roleName == "host" ||
                _vm.meeting.isScreenSharingEnabled)
                ? [
                    _vm.meeting.is_connected
                      ? _c("v-divider", {
                          staticClass: "d-none d-sm-flex",
                          attrs: { vertical: "" },
                        })
                      : _vm._e(),
                    _c(
                      "v-btn",
                      {
                        staticClass: "d-none d-sm-flex",
                        attrs: {
                          color:
                            _vm.meeting.is_local_screen_shared ||
                            _vm.meeting.is_whiteboard_active ||
                            _vm.meeting.video_playlist.length > 0 ||
                            _vm.meeting.audio_playlist.length > 0
                              ? "red"
                              : "",
                        },
                        on: {
                          click: function ($event) {
                            _vm.meeting.is_local_screen_shared ||
                            _vm.meeting.is_whiteboard_active ||
                            _vm.meeting.video_playlist.length > 0 ||
                            _vm.meeting.audio_playlist.length > 0
                              ? _vm.toggleScreenshare()
                              : (_vm.show_share_dialog = true)
                          },
                        },
                      },
                      [
                        _c("span", [_vm._v("Share")]),
                        _c("v-icon", [_vm._v("mdi-monitor-share")]),
                      ],
                      1
                    ),
                  ]
                : _vm._e(),
              _vm.meeting.is_connected &&
              _vm.meeting.local_peer.roleName == "host"
                ? _c("v-divider", {
                    staticClass: "d-none d-sm-flex",
                    attrs: { vertical: "" },
                  })
                : _vm._e(),
              _vm.meeting.is_connected &&
              _vm.meeting.local_peer.roleName == "host"
                ? _c(
                    "v-btn",
                    {
                      staticClass: "d-none d-sm-flex",
                      class: { red: _vm.isRecording },
                      attrs: { loading: _vm.meeting.recording_starting },
                      on: {
                        click: function ($event) {
                          return _vm.toggleRecord()
                        },
                      },
                    },
                    [
                      _c("span", [_vm._v("Record")]),
                      _c("v-icon", [_vm._v("mdi-record-circle-outline")]),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.user.hasRole("administrator") ||
              (_vm.user.userdata &&
                _vm.user.userdata.allcaps &&
                _vm.user.userdata.allcaps.manage_livestream)
                ? [
                    _vm.meeting.is_connected &&
                    _vm.meeting.local_peer.roleName == "host"
                      ? _c("v-divider", {
                          staticClass: "d-none d-sm-flex",
                          attrs: { vertical: "" },
                        })
                      : _vm._e(),
                    _vm.meeting.is_connected &&
                    _vm.meeting.local_peer.roleName == "host"
                      ? _c(
                          "v-btn",
                          {
                            staticClass: "d-none d-sm-flex",
                            class: `${
                              _vm.meeting.livestream_state.running ? "red" : ""
                            }`,
                            attrs: { loading: _vm.livestream_starting },
                            on: {
                              click: function ($event) {
                                _vm.meeting.livestream_state.running
                                  ? _vm.toggleLivestream()
                                  : (_vm.show_livestream_dialog = true)
                              },
                            },
                          },
                          [
                            _c("span", [_vm._v("Livestream")]),
                            _c("v-icon", [_vm._v("mdi-broadcast")]),
                          ],
                          1
                        )
                      : _vm._e(),
                  ]
                : _vm._e(),
              _vm.meeting.is_connected
                ? _c("v-divider", {
                    staticClass: "d-none d-sm-flex",
                    attrs: { vertical: "" },
                  })
                : _vm._e(),
              _vm.meeting.is_connected
                ? _c(
                    "v-btn",
                    {
                      staticClass: "d-none d-sm-flex",
                      on: {
                        click: () => {
                          _vm.meeting.participants_chat_switch = "participants"
                          _vm.meeting.show_nav_drawer = true
                        },
                      },
                    },
                    [
                      _c("span", [
                        _vm._v(
                          _vm._s(
                            _vm.meeting.peers.filter(
                              (peer) =>
                                ["guest", "host"].includes(peer.roleName) ||
                                (["guest", "host", "coach"].includes(
                                  peer.roleName
                                ) &&
                                  _vm.meeting.local_peer.roleName != "guest")
                            ).length
                          )
                        ),
                      ]),
                      _c("v-icon", [_vm._v("mdi-account")]),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.meeting.is_connected
                ? _c("v-divider", { attrs: { vertical: "" } })
                : _vm._e(),
              _vm.meeting.is_connected
                ? _c(
                    "v-btn",
                    {
                      on: {
                        click: () => {
                          _vm.meeting.participants_chat_switch = "chat"
                          _vm.meeting.show_nav_drawer = true
                        },
                      },
                    },
                    [
                      _c("span", [_vm._v("Chat")]),
                      _vm.meeting.new_message_count > 0
                        ? _c(
                            "v-badge",
                            {
                              attrs: {
                                color: "success",
                                content: _vm.meeting.new_message_count,
                              },
                            },
                            [_c("v-icon", [_vm._v("mdi-message")])],
                            1
                          )
                        : _c("v-icon", [_vm._v("mdi-message")]),
                    ],
                    1
                  )
                : _vm._e(),
              _c("v-divider", { attrs: { vertical: "" } }),
              _c(
                "v-btn",
                {
                  on: {
                    click: function ($event) {
                      _vm.meeting.show_settings = true
                    },
                  },
                },
                [
                  _c("span", [_vm._v("Settings")]),
                  _c("v-icon", [_vm._v("mdi-cog")]),
                ],
                1
              ),
              _vm.meeting.is_connected
                ? _c("v-divider", { attrs: { vertical: "" } })
                : _vm._e(),
              _vm.meeting.is_connected
                ? _c(
                    "v-btn",
                    {
                      attrs: { color: "red" },
                      on: {
                        click: function ($event) {
                          return _vm.leave()
                        },
                      },
                    },
                    [_c("v-icon", [_vm._v("mdi-logout")])],
                    1
                  )
                : _vm._e(),
            ],
            2
          )
        : _vm._e(),
      _c(
        "v-overlay",
        { attrs: { value: _vm.starting_cobrowse || _vm.ending_cobrowse } },
        [
          _c("v-progress-circular", {
            attrs: { indeterminate: "", size: "64" },
          }),
        ],
        1
      ),
      _c(
        "v-dialog",
        {
          attrs: { maxWidth: "600" },
          model: {
            value: _vm.show_cobrowse_dialog,
            callback: function ($$v) {
              _vm.show_cobrowse_dialog = $$v
            },
            expression: "show_cobrowse_dialog",
          },
        },
        [
          _c(
            "v-card",
            [
              _c("v-card-title", [_vm._v(" Begin Co-browsing Session ")]),
              _c(
                "v-card-text",
                [
                  _vm._v(
                    " You can share and collaborate on almost any webpage with other users. Enter a website URL to get started. "
                  ),
                  _c("v-text-field", {
                    staticClass: "mt-4",
                    attrs: { outlined: "", label: "Enter a URL" },
                    model: {
                      value: _vm.cobrowse_url,
                      callback: function ($$v) {
                        _vm.cobrowse_url = $$v
                      },
                      expression: "cobrowse_url",
                    },
                  }),
                  _vm.cobrowse_urls.length > 0
                    ? _c(
                        "v-sheet",
                        {
                          staticClass: "overflow-y-auto pa-2",
                          attrs: { "max-height": "300", outlined: "" },
                        },
                        [
                          _c(
                            "v-list",
                            [
                              _c(
                                "v-list-item-group",
                                {
                                  model: {
                                    value: _vm.selected_url,
                                    callback: function ($$v) {
                                      _vm.selected_url = $$v
                                    },
                                    expression: "selected_url",
                                  },
                                },
                                [
                                  _vm._l(_vm.cobrowse_urls, function (url) {
                                    return [
                                      _c("v-list-item", {
                                        key: url,
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function () {
                                                return [
                                                  _c(
                                                    "v-list-item-content",
                                                    [
                                                      _c("v-list-item-title", {
                                                        domProps: {
                                                          textContent:
                                                            _vm._s(url),
                                                        },
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            _vm.cobrowse_url =
                                                              url
                                                          },
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  ),
                                                  _c(
                                                    "v-list-item-action",
                                                    [
                                                      _c(
                                                        "v-btn",
                                                        {
                                                          attrs: { icon: "" },
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              return _vm.removeUrlHistory(
                                                                url
                                                              )
                                                            },
                                                          },
                                                        },
                                                        [
                                                          _c("v-icon", [
                                                            _vm._v("mdi-close"),
                                                          ]),
                                                        ],
                                                        1
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                ]
                                              },
                                              proxy: true,
                                            },
                                          ],
                                          null,
                                          true
                                        ),
                                      }),
                                    ]
                                  }),
                                ],
                                2
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      on: {
                        click: function ($event) {
                          _vm.show_cobrowse_dialog = false
                        },
                      },
                    },
                    [_vm._v("Cancel")]
                  ),
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.startCobrowse()
                        },
                      },
                    },
                    [_vm._v("Start Co-browsing Session")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-dialog",
        {
          attrs: { maxWidth: "500" },
          model: {
            value: _vm.show_end_cobrowse_dialog,
            callback: function ($$v) {
              _vm.show_end_cobrowse_dialog = $$v
            },
            expression: "show_end_cobrowse_dialog",
          },
        },
        [
          _c(
            "v-card",
            [
              _c("v-card-title", [_vm._v("End Co-browsing Session?")]),
              _c("v-card-text", [
                _vm._v(
                  " Are you sure you want to end your co-browsing session? "
                ),
              ]),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      on: {
                        click: function ($event) {
                          _vm.show_end_cobrowse_dialog = false
                        },
                      },
                    },
                    [_vm._v("Close")]
                  ),
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "red" },
                      on: {
                        click: function ($event) {
                          return _vm.endCobrowse()
                        },
                      },
                    },
                    [_vm._v("Stop Co-browsing")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-dialog",
        {
          attrs: { maxWidth: "500" },
          model: {
            value: _vm.show_whiteboard_dialog,
            callback: function ($$v) {
              _vm.show_whiteboard_dialog = $$v
            },
            expression: "show_whiteboard_dialog",
          },
        },
        [
          _c(
            "v-card",
            [
              _c("v-card-title", [_vm._v(" Begin Whiteboard Session ")]),
              _c(
                "v-card-text",
                [
                  _vm._v(
                    " Enter the URL of your whiteboard app (i.e. Miro.com) to share it in the meeting. "
                  ),
                  _c("v-text-field", {
                    staticClass: "mt-4",
                    attrs: { outlined: "", label: "Enter a URL" },
                    model: {
                      value: _vm.meeting.whiteboard_url,
                      callback: function ($$v) {
                        _vm.$set(_vm.meeting, "whiteboard_url", $$v)
                      },
                      expression: "meeting.whiteboard_url",
                    },
                  }),
                  _vm.whiteboard_urls.length > 0
                    ? _c(
                        "v-sheet",
                        {
                          staticClass: "overflow-y-auto pa-2",
                          attrs: { "max-height": "300", outlined: "" },
                        },
                        [
                          _c(
                            "v-list",
                            [
                              _c(
                                "v-list-item-group",
                                {
                                  model: {
                                    value: _vm.selected_url,
                                    callback: function ($$v) {
                                      _vm.selected_url = $$v
                                    },
                                    expression: "selected_url",
                                  },
                                },
                                [
                                  _vm._l(_vm.whiteboard_urls, function (url) {
                                    return [
                                      _c("v-list-item", {
                                        key: url,
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function () {
                                                return [
                                                  _c(
                                                    "v-list-item-content",
                                                    [
                                                      _c("v-list-item-title", {
                                                        domProps: {
                                                          textContent:
                                                            _vm._s(url),
                                                        },
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            _vm.meeting.whiteboard_url =
                                                              url
                                                          },
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  ),
                                                  _c(
                                                    "v-list-item-action",
                                                    [
                                                      _c(
                                                        "v-btn",
                                                        {
                                                          attrs: { icon: "" },
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              return _vm.removeUrlHistory(
                                                                url
                                                              )
                                                            },
                                                          },
                                                        },
                                                        [
                                                          _c("v-icon", [
                                                            _vm._v("mdi-close"),
                                                          ]),
                                                        ],
                                                        1
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                ]
                                              },
                                              proxy: true,
                                            },
                                          ],
                                          null,
                                          true
                                        ),
                                      }),
                                    ]
                                  }),
                                ],
                                2
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      on: {
                        click: function ($event) {
                          _vm.show_whiteboard_dialog = false
                        },
                      },
                    },
                    [_vm._v("Cancel")]
                  ),
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.startWhiteboardSession()
                        },
                      },
                    },
                    [_vm._v("Start Whiteboard Session")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-dialog",
        {
          attrs: { maxWidth: "400" },
          model: {
            value: _vm.show_livestream_dialog,
            callback: function ($$v) {
              _vm.show_livestream_dialog = $$v
            },
            expression: "show_livestream_dialog",
          },
        },
        [
          _c(
            "v-card",
            [
              _c(
                "v-card-title",
                [
                  _c(
                    "v-row",
                    [
                      _c(
                        "v-col",
                        { staticClass: "grow" },
                        [
                          _c(
                            "v-icon",
                            { staticClass: "mr-2", attrs: { color: "red" } },
                            [_vm._v("mdi-broadcast")]
                          ),
                          _vm._v(" Livestreaming "),
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        { staticClass: "shrink" },
                        [
                          _c(
                            "v-btn",
                            {
                              attrs: { icon: "" },
                              on: {
                                click: function ($event) {
                                  _vm.show_livestream_dialog = false
                                },
                              },
                            },
                            [_c("v-icon", [_vm._v("mdi-close")])],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "v-card-text",
                { staticClass: "pt-6" },
                [
                  _c("v-text-field", {
                    staticClass: "mb-2",
                    attrs: {
                      outlined: "",
                      label: "Title",
                      dense: "",
                      "hide-details": "",
                      required: "",
                      "error-messages": _vm.livestream_title_errors,
                    },
                    model: {
                      value: _vm.livestream_title,
                      callback: function ($$v) {
                        _vm.livestream_title = $$v
                      },
                      expression: "livestream_title",
                    },
                  }),
                  _c("v-textarea", {
                    staticClass: "my-1",
                    attrs: {
                      outlined: "",
                      rows: "3",
                      dense: "",
                      "hide-details": "",
                      label: "Description",
                    },
                    model: {
                      value: _vm.livestream_description,
                      callback: function ($$v) {
                        _vm.livestream_description = $$v
                      },
                      expression: "livestream_description",
                    },
                  }),
                  _c("p", [_vm._v("Privacy Status:")]),
                  _c(
                    "v-radio-group",
                    {
                      attrs: { row: "", mandatory: "" },
                      model: {
                        value: _vm.livestream_privacy,
                        callback: function ($$v) {
                          _vm.livestream_privacy = $$v
                        },
                        expression: "livestream_privacy",
                      },
                    },
                    [
                      _c("v-radio", {
                        attrs: { label: "Public", value: "public" },
                      }),
                      _c("v-radio", {
                        attrs: { label: "Unlisted", value: "unlisted" },
                      }),
                      _c("v-radio", {
                        attrs: { label: "Private", value: "private" },
                      }),
                    ],
                    1
                  ),
                  _vm.meeting.livestream_state.running
                    ? _c(
                        "v-btn",
                        {
                          attrs: {
                            color: "red",
                            block: "",
                            loading: _vm.meeting.rtmp_stopping,
                          },
                          on: {
                            click: function ($event) {
                              return _vm.toggleLivestream(true)
                            },
                          },
                        },
                        [
                          _c("v-icon", { staticClass: "mr-2" }, [
                            _vm._v("mdi-youtube"),
                          ]),
                          _vm._v(" Stop Livestream "),
                        ],
                        1
                      )
                    : _c(
                        "v-btn",
                        {
                          attrs: {
                            color: "red",
                            block: "",
                            loading:
                              _vm.meeting.rtmp_starting ||
                              _vm.connecting_to_youtube,
                          },
                          on: {
                            click: function ($event) {
                              return _vm.createLiveBroadcast()
                            },
                          },
                        },
                        [
                          _c("v-icon", { staticClass: "mr-2" }, [
                            _vm._v("mdi-youtube"),
                          ]),
                          _vm._v(" Start Youtube Livestream "),
                        ],
                        1
                      ),
                  _c("div", { staticClass: "text-center" }, [
                    _vm._v(
                      _vm._s(
                        _vm.meeting.livestream_state.running
                          ? "Livestreaming"
                          : _vm.livestream_status_message
                      )
                    ),
                  ]),
                  _c("div", { staticClass: "text-center my-2" }, [
                    _c("small", [
                      _vm._v(
                        "VIPHuddles.com's use and transfer of information received from Google APIs to any other app will adhere to "
                      ),
                      _c(
                        "a",
                        {
                          attrs: {
                            href: "https://developers.google.com/terms/api-services-user-data-policy",
                            target: "_blank",
                          },
                        },
                        [_vm._v(" Google API Services User Data Policy ")]
                      ),
                      _vm._v(", including the Limited Use requirements."),
                      _c("br"),
                      _c("br"),
                      _vm._v(" VIPHuddles.com "),
                      _c(
                        "a",
                        {
                          attrs: {
                            href: "https://viphuddles.com/privacy-policy/",
                            target: "_blank",
                          },
                        },
                        [_vm._v("Privacy Policy")]
                      ),
                    ]),
                  ]),
                  _c("div", { staticClass: "error" }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-dialog",
        {
          attrs: { maxWidth: "400" },
          model: {
            value: _vm.show_share_dialog,
            callback: function ($$v) {
              _vm.show_share_dialog = $$v
            },
            expression: "show_share_dialog",
          },
        },
        [
          _c(
            "v-card",
            [
              _c(
                "v-card-title",
                [
                  _c(
                    "v-row",
                    [
                      _c(
                        "v-col",
                        { staticClass: "grow" },
                        [
                          _c(
                            "v-icon",
                            { staticClass: "mr-2", attrs: { color: "red" } },
                            [_vm._v("mdi-monitor-share")]
                          ),
                          _vm._v(" Share Content "),
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        { staticClass: "shrink" },
                        [
                          _c(
                            "v-btn",
                            {
                              attrs: { icon: "" },
                              on: {
                                click: function ($event) {
                                  _vm.show_share_dialog = false
                                },
                              },
                            },
                            [_c("v-icon", [_vm._v("mdi-close")])],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "v-card-text",
                { staticClass: "pt-6" },
                [
                  _c(
                    "v-row",
                    [
                      _c(
                        "v-col",
                        { staticClass: "pb-6", attrs: { cols: "12" } },
                        [
                          _c(
                            "v-btn",
                            {
                              staticClass: "mb-4",
                              attrs: {
                                block: "",
                                color: "primary",
                                "x-large": "",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.toggleScreenshare()
                                },
                              },
                            },
                            [_vm._v("Screen")]
                          ),
                          _c(
                            "v-btn",
                            {
                              staticClass: "mb-4",
                              attrs: {
                                block: "",
                                color: "primary",
                                "x-large": "",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.toggleWhiteboard()
                                },
                              },
                            },
                            [_vm._v("Whiteboard")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "v-row",
                    [
                      _c("v-col", { attrs: { cols: "12" } }, [
                        _vm._v("Share a Video"),
                      ]),
                      _c(
                        "v-col",
                        { attrs: { cols: "8" } },
                        [
                          _c("v-file-input", {
                            attrs: {
                              outlined: "",
                              accept: "video/*",
                              label: "Video file",
                              dense: "",
                            },
                            model: {
                              value: _vm.video_file,
                              callback: function ($$v) {
                                _vm.video_file = $$v
                              },
                              expression: "video_file",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        { attrs: { cols: "4" } },
                        [
                          _c(
                            "v-btn",
                            {
                              attrs: { block: "", color: "primary" },
                              on: {
                                click: function ($event) {
                                  return _vm.shareVideo()
                                },
                              },
                            },
                            [_vm._v("Share")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "v-row",
                    [
                      _c("v-col", { attrs: { cols: "12" } }, [
                        _vm._v("Share Audio"),
                      ]),
                      _c(
                        "v-col",
                        { attrs: { cols: "8" } },
                        [
                          _c("v-file-input", {
                            attrs: {
                              outlined: "",
                              accept: "audio/*",
                              label: "Audio file",
                              dense: "",
                            },
                            model: {
                              value: _vm.audio_file,
                              callback: function ($$v) {
                                _vm.audio_file = $$v
                              },
                              expression: "audio_file",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        { attrs: { cols: "4" } },
                        [
                          _c(
                            "v-btn",
                            {
                              attrs: { block: "", color: "primary" },
                              on: {
                                click: function ($event) {
                                  return _vm.shareAudio()
                                },
                              },
                            },
                            [_vm._v("Share")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }